

























































import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import Accordion from '../../../../Accordion/Accordion.vue'
import CustomEditor from '../../logic/Editor/CustomEditor'
import ContextMenuItem from '../ContextMenu/components/Menu/ContextMenuItem.vue'
import { BaseMenuItems } from '../ContextMenu/logic/MenuItems'

@Component({
  data() {
    return {
      snakeCase,
    }
  },
  components: {
    Accordion,
    ContextMenuItem
  }
})
export default class MobileAddNodeMenu extends Vue {
  @Prop() editor!: CustomEditor

  isOpen = false

  get menuItems() {
    return BaseMenuItems
  }

  createNode(type: string): void {
    const { x,y,k } = this.editor.view.area.transform
    const oX = (x / k) * -1,
          oY = (y / k) * -1

    const centerX = oX + ((window.innerWidth / 2) / k)
    const centerY = oY + ((window.innerHeight / 2) / k)

    this.editor.createNewNode(type, { x: centerX, y: centerY })

    this.isOpen = false
  }
}
